/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState } from 'react';

// Create a context for managing node data
const NodeContext = createContext();

// Custom hook to use the node context
export const useNodeContext = () => {
  const context = useContext(NodeContext);
  if (!context) {
    throw new Error('useNodeContext must be used within a NodeProvider');
  }
  return context;
};

// Provider component that wraps the application or relevant part
export const NodeProvider = ({ children, id, type, metaData, nodeData }) => {
  const [node, setNode] = useState({
    data: nodeData,
    id,
    type,
    metaData,
  });
  const getCurrentActiveNodeInContext = () => {
    return node;
  };
  const setCurrentActiveNodeInContext = ({ data, id, type, metaData }) => {
    setNode({
      data,
      id,
      type,
      metaData,
    });
  };
  const updateNodeData = (data) => {
    setNode({
      ...node,
      data,
    });
  };
  return (
    <NodeContext.Provider
      value={{
        node,
        setNode,
        getCurrentActiveNodeInContext,
        setCurrentActiveNodeInContext,
        updateNodeData,
      }}
    >
      {children}
    </NodeContext.Provider>
  );
};
